



















































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BFormRadio,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { TypePartenaireFasttCreateModel } from "@/api/models/FASTT/typesPartenaire/typesPartenaire";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormRadio,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-type-partenaire",
})
export default class CreateTypePartenaire extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewTypePartenaireSidebarActive!: boolean;
  loading = false;

  required = required;
  listTypesServices: any[] = [];
  totalCountTypeServices = 0;

  newTypePartenaire: TypePartenaireFasttCreateModel = {};

  async created() {
  }

  resetForm() {
    this.newTypePartenaire = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.typesPartenaireFASTT
      .post(this.newTypePartenaire)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un type de partenaire FASTT",
            text: "Type de partenaire FASTT créé dans MyRessif avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refetch-data");
        this.$emit("update:is-add-new-type-partenaire-sidebar-active", false);
        this.loading = false;
      });
  }
}
